export default __webpack_public_path__ + "static/media/UseCaseCard3.a8bae559.svg";